import React, { Component } from 'react';
import Config from './Config';
//import { Scrollbars } from 'react-custom-scrollbars';
import './css/ProductImages.css';
import FX from './functions/functions';



class ProductImages extends Component {
  
  upImg = (e) => {
    
     console.log(e);
     console.log(e.nativeEvent);
     console.log(e.target);
     if(!e.target.files.length){
       return false;
     }
     var reader = new FileReader();
     
     reader.onload = (event) => {
         // Images attach to this.props.product directly; no catalogue lookup
         // is needed (the previous products.list scan was dead code).
         var detail = this.props.root.state.detail;

          detail.image.push({id: -1, add:true, img : event.target.result });
          
          this.props.root.setState({detail:detail});
          document.getElementById('newImg').value = '';
     };
     reader.onerror = function(event) {
         console.error("File could not be read! Code " + event.target.error.code);
     };
     reader.readAsDataURL(e.target.files[0]);
     
     console.log(e.target.files);
     
  }
  markDelete = (index) => {
      if(window.confirm('Do you want to delete this image')){
        var detail = this.props.root.state.detail;
        if(detail.image[index].id == -1){
           detail.image.splice(index,1);
        }
        else {
           detail.image[index].deleteImg = true;
        }
        this.props.root.setState({detail:detail});
     }
  }
  
  render() {
    var className;
    className = 'ProductImages';
    var images = [];
    if(this.props.images != undefined){
        images = this.props.images.map ((img,i) => {
      console.log(img);
      if(img.id == -1){
          return (<div className="imageHolder uploaded"><span  onClick={this.markDelete.bind(this,i)} className="delImg"><i className="fa fa-times" /></span><img src={img.img}/></div>);
      }
      else {
        if(!img.deleteImg){
          return (<div className="imageHolder"><span  onClick={this.markDelete.bind(this,i)} className="delImg"><i className="fa fa-times" /></span><img src={this.props.root.paths.imgHost + img.path + '?' + img.md5}/></div>);
        }
      }
    })
    }
    return (
      <div className={className} id="ProductImages">
        <div id="ImgList">
            {images}
        </div>
        <div className="add_image"><i className="material-icons">add_circle_outline</i><span>Add Image</span><input id="newImg" type="file" onChange={this.upImg} /></div>
      </div>
    );
  }
}

export default ProductImages;



// WEBPACK FOOTER //
// ./src/ProductImages.js